import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=30a25bbf&scoped=true&"
import script from "./MedicalRecord.vue?vue&type=script&lang=js&"
export * from "./MedicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=30a25bbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a25bbf",
  null
  
)

export default component.exports